"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragQuestion = void 0;
const lodash_1 = require("lodash");
var DragQuestion;
(function (DragQuestion) {
    DragQuestion.type = 'dragQuestion';
    let Components;
    (function (Components) {
        function componentsWithoutCorrectAnswer(components) {
            return components.map((c) => {
                return (0, lodash_1.omit)(c, 'settings.correctDropzone');
            });
        }
        Components.componentsWithoutCorrectAnswer = componentsWithoutCorrectAnswer;
        function lessonComponentsFromAssignmentComponents(components, correctAnswer) {
            return components.map((c) => {
                const c2 = (0, lodash_1.cloneDeep)(c);
                if (correctAnswer && correctAnswer.correctDropzone[c._id]) {
                    c2.settings.correctDropzone = correctAnswer.correctDropzone[c._id];
                }
                return c2;
            });
        }
        Components.lessonComponentsFromAssignmentComponents = lessonComponentsFromAssignmentComponents;
    })(Components = DragQuestion.Components || (DragQuestion.Components = {}));
})(DragQuestion || (exports.DragQuestion = DragQuestion = {}));
(function (DragQuestion) {
    let Components;
    (function (Components) {
        function getAllDropZones(list) {
            return list.filter((c) => c.type === 'dropzone');
        }
        Components.getAllDropZones = getAllDropZones;
        function getAllDragComponents(list) {
            return list.filter((c) => c.settings.isDraggable && c.type !== 'dropzone');
        }
        Components.getAllDragComponents = getAllDragComponents;
        function dragComponentWithAnswer(list) {
            return list.filter((c) => c.settings.correctDropzone && c.settings.correctDropzone.length);
        }
        Components.dragComponentWithAnswer = dragComponentWithAnswer;
        function dragComponentWithoutAnswer(list) {
            return list.filter((c) => !c.settings.correctDropzone || !c.settings.correctDropzone.length);
        }
        Components.dragComponentWithoutAnswer = dragComponentWithoutAnswer;
        function getNonDragQuestionComponents(list) {
            return list.filter((c) => !c.settings.isDraggable && c.type !== 'dropzone');
        }
        Components.getNonDragQuestionComponents = getNonDragQuestionComponents;
        function componentsForDropzone(dropZoneId, list) {
            return list.filter((c) => c.settings.correctDropzone && c.settings.correctDropzone.includes(dropZoneId));
        }
        Components.componentsForDropzone = componentsForDropzone;
        function order(cArr) {
            const normal = getNonDragQuestionComponents(cArr);
            const dropZones = getAllDropZones(cArr);
            const draggables = getAllDragComponents(cArr);
            return [...normal, ...dropZones, ...draggables];
        }
        Components.order = order;
    })(Components = DragQuestion.Components || (DragQuestion.Components = {}));
    let Answer;
    (function (Answer) {
        function create(fields) {
            return Object.assign({}, fields);
        }
        Answer.create = create;
        function isCorrectAnswer(answer) {
            return (answer &&
                answer.correctDropzone &&
                !(0, lodash_1.find)(answer.correctDropzone, (compAnswer) => !Array.isArray(compAnswer) || compAnswer.find((a) => typeof a !== 'string')));
        }
        Answer.isCorrectAnswer = isCorrectAnswer;
        function update(current, fields) {
            const merge = Object.assign({}, current, fields);
            merge.components = Object.assign({}, current.components, fields.components);
            return merge;
        }
        Answer.update = update;
        function totalNumberOfCorrect(answer) {
            if (!answer)
                return 0;
            return (0, lodash_1.filter)(answer.correctDropzone, (c) => c.length > 0).length;
        }
        Answer.totalNumberOfCorrect = totalNumberOfCorrect;
        function rankingPointsForResult(result) {
            if (result && result.type === 'correct')
                return 1;
            return 0;
        }
        Answer.rankingPointsForResult = rankingPointsForResult;
        function testPointsForResult(maxPoints, result) {
            if (result && result.type === 'correct')
                return maxPoints;
            return undefined;
        }
        Answer.testPointsForResult = testPointsForResult;
        function isSubmitted(pinEntry) {
            if (pinEntry && pinEntry.answer && pinEntry.answer.submitted)
                return true;
            return false;
        }
        Answer.isSubmitted = isSubmitted;
        function resultForAnswer(current, optionalCorrectAnswer) {
            const correctAnswer = optionalCorrectAnswer || { correctDropzone: {} };
            const max = Object.values(correctAnswer.correctDropzone).filter((list) => list.length).length;
            const cur = (current && current.components) || {};
            const count = { num: 0, total: max };
            const components = {};
            // always return complete list of components with correct/ incorrect status for rendering checkboxes
            (0, lodash_1.forEach)(correctAnswer.correctDropzone, (list, componentId) => {
                if (list.length === 0) {
                    // If no correct dropzones are defined, it's an opinion question in which case every answer is correct.
                    components[componentId] = cur[componentId] && count.total > 0 ? 'incorrect' : 'correct';
                }
                else {
                    const answer = (cur[componentId] && cur[componentId].inDropzone) || '';
                    const isCorrect = list.includes(answer);
                    if (isCorrect)
                        count.num++;
                    components[componentId] = isCorrect ? 'correct' : 'incorrect';
                }
            });
            const type = count.num === count.total ? 'correct' : count.total && count.num === 0 ? 'incorrect' : 'partialCorrect';
            if (!current) {
                return { type: 'noAnswer', components, count };
            }
            return { type, components, count };
        }
        Answer.resultForAnswer = resultForAnswer;
        function isDone(answer) {
            return !(0, lodash_1.isNil)(answer) && !(0, lodash_1.isEmpty)(answer.components);
        }
        Answer.isDone = isDone;
    })(Answer = DragQuestion.Answer || (DragQuestion.Answer = {}));
})(DragQuestion || (exports.DragQuestion = DragQuestion = {}));
//# sourceMappingURL=DragQuestion.js.map